module.exports = __webpack_public_path__ + "static/media/LAZ_04.585cc17b.jpg";